import { i18n } from '@wms/shared';

const { t } = i18n;

export function DeliveryGroupItems({
  groupCount,
  lines,
  orderLines,
}: {
  groupCount: number;
  lines: readonly { orderLineId: string; qty: string | number }[];
  orderLines: readonly {
    id: string;
    product: { code: string; nameLt: string };
  }[];
}) {
  if (groupCount <= 1) return null;
  return (
    <div className="mt-3 border-t border-border pt-2">
      <div className="text-xs font-medium">{t('order.groups.items_for_address')}</div>
      <ul className="mt-1 space-y-1 text-xs">
        {lines.map((groupLine) => {
          const orderLine = orderLines.find((line) => line.id === groupLine.orderLineId);
          return (
            <li key={groupLine.orderLineId} className="flex gap-2">
              <span className="font-medium tabular-nums">
                {Number(groupLine.qty).toLocaleString('lt-LT')} ×
              </span>
              <span>
                {orderLine
                  ? `${orderLine.product.code} — ${orderLine.product.nameLt}`
                  : groupLine.orderLineId}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
